// extracted by mini-css-extract-plugin
export var explainable = "_g0-a";
export var printerCard = "_g0-1";
export var printerCardConfigured = "_g0-2";
export var printerCardError = "_g0-3";
export var printerCardsContainer = "_g0-0";
export var printerIcon = "_g0-8";
export var printerIconConfigured = "_g0-5";
export var printerIconContainer = "_g0-4";
export var printerIconError = "_g0-6";
export var printerIconUnconfigured = "_g0-7";
export var workstationsTableCard = "_g0-9";